export const ERROR_CODES = {
  FETCH_ERROR: 'FETCH_ERROR',
  UNABLE_CREATE: 'UNABLE_CREATE',
}

export const ERROR_DISPLAY_TYPES = {
  IN_PAGE: 'IN_PAGE',
  FULL_SHEET: 'FULL_SHEET',
  FULLSCREEN: 'FULLSCREEN',
  REDIRECT: 'REDIRECT',
  DISPATCH: 'DISPATCH',
}

export const COVER_IMAGE_UPLOAD_ERRORS = {
  FILE_INVALID_TYPE: 'file-invalid-type',
  FILE_TOO_LARGE: 'file-too-large',
  FILE_TOO_SMALL: 'file-too-small',
  TOO_MANY_FILES: 'too-many-files',
}

export const coverImageErrorCodeMapping = {
  [COVER_IMAGE_UPLOAD_ERRORS.FILE_INVALID_TYPE]:
    'imageUploadField.error.invalid.type',
  [COVER_IMAGE_UPLOAD_ERRORS.FILE_TOO_LARGE]:
    'imageUploadField.error.file.too.large',
  [COVER_IMAGE_UPLOAD_ERRORS.FILE_TOO_SMALL]:
    'imageUploadField.error.file.too.small',
}

export const VALIDATION_ERRORS = {
  EMPTY_FIELD: 'EMPTY_FIELD',
  MAX_LENGTH_EXCEEDED: 'MAX_LENGTH_EXCEEDED',
  REGEX_FAILED: 'REGEX_FAILED',
  DATE_EXCEEDS_MAX: 'DATE_EXCEEDS_MAX',
  DATE_IN_PAST: 'DATE_IN_PAST',
  AMOUNT_EXCEEDED: 'AMOUNT_EXCEEDED',
}
